import { ScreenApp, Size } from '@appsinti/common-utils/interfaces/IApp';

export const resolveGridSize = (app: ScreenApp): Size | undefined => {
  if (app.module === 'bigbrother') {
    return app.config.site ? app.config.size ?? 'quarter' : undefined;
  }
  return app.config.size;
};
